export default __webpack_public_path__ + "static/media/07.90301202.jpg";